import React from 'react'
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Select,
  message,
  notification,
} from 'antd'
import { NotificationService, InformfixService } from '../../../services'
import './style.scss'
import TextArea from 'antd/lib/input/TextArea'
import { openNotificationWithIcon } from '../../../helpers'
const { Option } = Select

class NotificationAdd extends React.Component {
  state = {
    loadingProject: false,
    loading: false,
    refItem: {},
    notificationType: {
      CUSTOMER_POSTPONE: '',
    },
    listType: [],
  }

  constructor() {
    super()
    this.formRef = React.createRef()
  }

  handleSubmit = (values) => {
    this.setState({ loading: true })
    // values = {
    //   ...values,
    //   ...{
    //     notification_type: this.props.notificationType,
    //     ref_id: this.props.refId,
    //   },
    // }
    console.log('values', values)
    // return false
    NotificationService.create(values).then((rs) => {
      if (rs) {
        console.log(rs)
        this.setState({ loading: false })
        message.success(rs.data['message'], 5)
        openNotificationWithIcon('success', rs.data.message)
        this.props.hideModal()
      }
    })
  }

  UNSAFE_componentWillMount() {
    const type = this.props.notificationType
    if (type == 'CUSTOMER_POSTPONE') {
      InformfixService.view(this.props.refId).then((rs) => {
        if (rs) {
          this.setState({
            refItem: rs.data.data,
          })
        }
      })
    }

    this.getListType()
    // this.formRef.current.setFieldsValue({
    //   ref_id: this.props.refId,
    //   notification_type: this.props.notificationType,
    // })
  }

  getListType = () => {
    NotificationService.listType().then((rs) => {
      this.setState({
        listType: rs.data.data,
      })
    })
  }

  render() {
    const { loading, listType } = this.state
    const { notificationType } = this.props
    const formLayout = 'horizontal'
    const formItemLayout =
      formLayout === 'horizontal'
        ? {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 9 },
              md: { span: 9 },
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 15 },
              md: { span: 15 },
            },
          }
        : null
    const buttonItemLayout =
      formLayout === 'horizontal'
        ? {
            wrapperCol: {
              xs: { span: 24, offset: 0 },
              sm: { span: 15, offset: 9 },
              md: { span: 15, offset: 9 },
            },
          }
        : null
    const showTypeNotification = () => {
      let name = ''
      if (listType) {
        listType.map((type, key) => {
          if (type.value == notificationType) {
            name = type.text
          }
        })
        console.log('xx', name)
      }
      return name
    }
    return (
      <React.Fragment>
        <div id="notification-form-add">
          {this.props.notificationType ? (
            <Form
              form={this.form}
              id="notificationform"
              onFinish={this.handleSubmit}
              layout={formLayout}
              ref={this.formRef}
              initialValues={{
                notification_type: this.props.notificationType,
                ref_id: this.props.refId,
              }}
            >
              <Row>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }}>
                  <Form.Item name="notification_type" noStyle>
                    <Input type="hidden" />
                  </Form.Item>
                  <Form.Item name="ref_id" noStyle>
                    <Input type="hidden" />
                  </Form.Item>
                  <Form.Item label="ประเภท" {...formItemLayout}>
                    {/* <Input value={this.state.listType[this.props.notificationType]}/> */}
                    <Select value={this.props.notificationType} disabled>
                      {listType.map((status, key) => (
                        <Option
                          key={key}
                          value={status.value}
                          label={status.text}
                        >
                          {status.text}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item label="Ref No." {...formItemLayout}>
                    <Input type="text" disabled value={this.props.refId}/>
                  </Form.Item>
                  {/* <Form.Item
                    label="ประเภทการแจ้งเตือน"
                    {...formItemLayout}
                    name="notification_type"
                    rules={[{ required: true, message: 'ประเภทการแจ้งเตือน' }]}
                  >
                    <Select readOnly>
                      {listType.map((t, key) => (
                        <Option key={key} value={t.value}>
                          {t.text}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item> */}
                  {/* <Form.Item label="Ref ID" {...formItemLayout} name="ref_id">
                    <Input type="text" placeholder="Ref ID" readOnly/>
                  </Form.Item> */}
                  <Form.Item
                    label="เรื่อง"
                    {...formItemLayout}
                    name="title"
                    rules={[
                      { required: true, message: 'กรุณากรอกชื่อเจ้าของบ้าน' },
                    ]}
                  >
                    <Input type="text" placeholder="เรื่อง" />
                  </Form.Item>
                  <Form.Item
                    label="รายละเอียด"
                    {...formItemLayout}
                    name="description"
                    rules={[{ required: true, message: 'กรุณากรอกรายละเอียด' }]}
                  >
                    <TextArea placeholder="รายละเอียด" rows={5}/>
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }}>
                  <Form.Item {...buttonItemLayout}>
                    <Button type="primary" htmlType="submit" className="submit">
                      บันทึก
                    </Button>{' '}
                    <Button
                      type="light"
                      htmlType="reset"
                      className="reset"
                      onClick={this.props.hideModal}
                    >
                      ยกเลิก
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          ) : null}
        </div>
      </React.Fragment>
    )
  }
}
export default NotificationAdd
